
import React from "react";
import {
  withGoogleMap,
  withScriptjs,
  GoogleMap,
  Marker,
} from "react-google-maps";
import InfoBox from "react-google-maps/lib/components/addons/InfoBox";

const Map = ({hotels}) => {
  
const options = { closeBoxURL: "", enableEventPropagation: true };
  return (
    <div>
      <GoogleMap
        defaultZoom={8}
        defaultCenter={{ lat: 21.188414, lng: 106.076744 }}
      >
        {hotels && hotels.map((map, index) => {
            return (
              <Marker
                icon={{
                  url: "/images/ic_hotel.png",
                  scaledSize: new window.google.maps.Size(40, 40),
                }}
                position={new window.google.maps.LatLng(map)}
              >
                <InfoBox options={options}>
                  <>
                    <div
                      style={{
                        backgroundColor: "#fff",
                        color: "#000",
                        borderRadius: "1em",
                        padding: "3px 10px",
                      }}
                    >
                      {map.name}
                    </div>
                  </>
                </InfoBox>
              </Marker>
            );
          })}
      </GoogleMap>
    </div>
  );
};

export default withScriptjs(withGoogleMap(Map));
